<template>
  <div ref="bdmap" class="container"></div>
</template>

<script>
  export default {
    methods: {},
    mounted: function() {
      //window.BMapGL_loadScriptTime = (new Date).getTime();
      console.log(this.$refs.bdmap);
      var map = new BMapGL.Map(this.$refs.bdmap);
      console.log(map);
      map.centerAndZoom(new BMapGL.Point(118.048844, 24.586368), 17);
      map.enableScrollWheelZoom(true);
      // 创建点标记
      var marker1 = new BMapGL.Marker(new BMapGL.Point(118.048844, 24.586368));
      //var marker2 = new BMapGL.Marker(new BMapGL.Point(118.042834, 24.584281));

      // 在地图上添加点标记
      map.addOverlay(marker1);
      //map.addOverlay(marker2);
    }
  }
</script>

<style scoped>
  .container {
    overflow: hidden;
    width: 1200px;
    height: 600px;
    margin: 0 auto;
    font-family: "微软雅黑";
    border:1px solid #3D3CFA
    }
</style>



// WEBPACK FOOTER //
// src/components/Map.vue